<template>
    <div v-if="visible" class="fu-modal-backdrop" @click.self="close">
        <div class="fu-modal-dialog">
            <div class="fu-modal-header">
                <h5 class="mb-0">
                    <i class="fas fa-sync-alt"></i> Tambah ke Follow Up
                </h5>
                <button type="button" class="btn-close" @click="close" aria-label="Close">&times;</button>
            </div>
            <div class="fu-modal-body">
                <div v-if="!hasFollowUpAddon" class="alert alert-warning">
                    <i class="fas fa-exclamation-triangle"></i>
                    Add-On Follow Up belum aktif. Upgrade paket untuk pakai fitur ini.
                </div>
                <template v-else>
                    <p class="mb-3">
                        <strong>Kontak:</strong>
                        {{ contactName || '-' }}
                        <small v-if="contactNumber" class="text-muted">({{ contactNumber }})</small>
                    </p>
                    <div v-if="isLoading" class="text-center py-3">
                        <i class="fas fa-spinner fa-spin"></i> Memuat daftar follow up...
                    </div>
                    <div v-else-if="activeFlows.length === 0" class="alert alert-info mb-0">
                        Belum ada Follow Up aktif. Buat flow baru dulu di menu Follow Up Otomatis.
                    </div>
                    <div v-else>
                        <label>Pilih Follow Up:</label>
                        <select v-model.number="selectedFollowUpId" class="form-control">
                            <option :value="null">-- Pilih --</option>
                            <option v-for="fu in activeFlows" :key="fu.id" :value="fu.id">
                                {{ fu.name }}
                                <template v-if="fu.trigger_tag"> (tag: {{ fu.trigger_tag }})</template>
                            </option>
                        </select>
                        <small class="form-text text-muted">
                            Kontak akan langsung masuk flow dari Step 1 sesuai delay yang di-set.
                        </small>
                    </div>
                </template>
            </div>
            <div class="fu-modal-footer">
                <button type="button" class="btn btn-secondary" @click="close" :disabled="isSubmitting">
                    Batal
                </button>
                <button type="button" class="btn btn-primary" @click="submit"
                        :disabled="!selectedFollowUpId || isSubmitting || !hasFollowUpAddon">
                    <i class="fas fa-paper-plane"></i>
                    {{ isSubmitting ? 'Memproses...' : 'Tambah ke Flow' }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AddToFlowModal',
    props: {
        visible: { type: Boolean, default: false },
        contactId: { type: Number, default: null },
        contactName: { type: String, default: '' },
        contactNumber: { type: String, default: '' }
    },
    data() {
        return {
            flows: [],
            selectedFollowUpId: null,
            isLoading: false,
            isSubmitting: false
        };
    },
    computed: {
        hasFollowUpAddon() {
            return this.$store.state.auth.package?.follow_up == 1;
        },
        activeFlows() {
            const now = Date.now();
            return this.flows.filter(f =>
                f.is_active == 1 &&
                (!f.expired_at || f.expired_at > now)
            ).sort((a, b) => (a.name || "").localeCompare(b.name || "", undefined, { numeric: true, sensitivity: "base" }));
        }
    },
    watch: {
        visible(newVal) {
            if (newVal && this.hasFollowUpAddon) {
                this.loadFlows();
                this.selectedFollowUpId = null;
            }
        }
    },
    methods: {
        async loadFlows() {
            this.isLoading = true;
            try {
                const response = await this.$store.dispatch("followup/followup_list", { page: 1, limit: 200 });
                this.flows = response.data.data.follow_ups || [];
            } catch (err) {
                this.$toast.error("Gagal memuat daftar follow up");
            } finally {
                this.isLoading = false;
            }
        },
        async submit() {
            if (!this.selectedFollowUpId || !this.contactId) return;
            this.isSubmitting = true;
            try {
                await this.$store.dispatch("followup/followup_trigger_manual", {
                    contact_id: this.contactId,
                    follow_up_id: this.selectedFollowUpId
                });
                this.$toast.success("Kontak berhasil ditambahkan ke follow up");
                this.$emit('added', { contactId: this.contactId, followUpId: this.selectedFollowUpId });
                this.close();
            } catch (err) {
                const msg = err.response?.data?.message || "Gagal menambahkan";
                this.$toast.error(msg);
            } finally {
                this.isSubmitting = false;
            }
        },
        close() {
            this.$emit('close');
        }
    }
};
</script>

<style scoped>
.fu-modal-backdrop {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
}
.fu-modal-dialog {
    background: #fff;
    border-radius: 12px;
    max-width: 500px;
    width: 95%;
    max-height: 90vh;
    overflow: auto;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}
.fu-modal-header {
    padding: 16px 20px;
    border-bottom: 1px solid #e9ecef;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.fu-modal-body {
    padding: 20px;
}
.fu-modal-footer {
    padding: 12px 20px;
    border-top: 1px solid #e9ecef;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
}
.btn-close {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    line-height: 1;
    padding: 0;
    color: #6c757d;
}
.btn-close:hover {
    color: #000;
}
</style>
